import { AuthService } from './../../../shared/services/auth.service';
import { IForgotPassword } from '../../../_models/Account/user';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-resend-confirm-link',
  templateUrl: './resend-confirm-link.component.html'
})
export class ResendConfirmLinkComponent implements OnInit {

  loading: boolean;
  resendConfirmLink: IForgotPassword;
  resendConfirmLinkForm: FormGroup;
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastrService: ToastrService,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.createLoginForm();
  }

  submit() {
    if (this.resendConfirmLinkForm.valid) {
      this.loading = true;
      this.resendConfirmLink = Object.assign({}, this.resendConfirmLinkForm.value);
      this.authService.resendConfirmLink(this.resendConfirmLink).subscribe(() => {
        this.toastrService.success('Confirmation link has been sent to your email ID.');
        this.router.navigate(['/home']);
      },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false
      );
    }
  }

  createLoginForm() {
    this.resendConfirmLinkForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }
}
